module.exports = __webpack_public_path__ + "images/fontawesome-webfont.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/vue-blu/dist/fonts/fontawesome-webfont.ttf
// module id = 950
// module chunks = 2